import { api } from "../api/client";
import { useBranding } from "../contexts/BrandingContext";

interface AppLogoProps {
  size?: "sm" | "lg";
}

const SIZES: Record<"sm" | "lg", number> = { sm: 32, lg: 96 };

export function AppLogo({ size = "sm" }: AppLogoProps) {
  const { logoVersion } = useBranding();
  const px = SIZES[size];
  return (
    <img
      src={api.logoUrl(logoVersion)}
      alt="logo"
      width={px}
      height={px}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}
